import http from '@/utils/http'

export function getUsers(params){
    return http.get('/users',{params})
}
export function getLearningRankingList(params){
    return http.get('/learningRankingList',{params})
}
export function addUser(data){
    return http.post('/users',data)
}
export function getUserDetail(id){
    return http.get(`/users/${id}`)
}
export function putUser(id,data){
    return http.put(`/users/${id}`,data)
}
export function putEditStudent(data){
    return http.put(`/editStudent`,data)
}
export function getTags(){
    return http.get('/getTags')
}
export function editTags(data){
    return http.put(`/editTags`,data)
}
export function changeSchools(data){
    return http.put(`/changeSchools`,data)
}
export function deleteUser(id){
    return http.delete(`/users/${id}`)
}

export function getRoles(){
    return http.get('/roles')
}
export function getAvatars(){
    return http.get('/avatars')
}
export function getUserGradeProgramInfos(id){
    return http.get(`/users/${id}/grade_program_infos`)
}